module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.sendModify()
      }
    }
  }, [_vm._v("\n  Modifier\n")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.sendSave()
      }
    }
  }, [_vm._v("\n  Enregistrer\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b960ab1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ModifySaveButton.vue
// module id = 1821
// module chunks = 2